module.exports = __webpack_public_path__ + "img/pro5.82123b63.png";